import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Col, Container, Row } from "reactstrap";
import { useHistory } from "react-router-dom";

import viewIcon from "../../assets/images/app/common/listing-view-image.svg";

import { Pagination } from "../../components/Pagination";
import { DataTable } from "../../components/DataTable";
import { GetUsers, UpdateUserStatusById } from "../../api/api.service";
import { useLocalPaginatedRequest } from "../../hooks/useLocalPaginatedRequest";
import { PageTitles } from "../../constants";
import { MODULE_KEYS, getKey } from "../../api/api.keys";
import { SearchBox } from "../../components/SearchBox";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import { SummaryCard } from "../../components/SummaryCard";
import { LABLES } from "./Config";
import { transformFiltersToArray, truncateString } from "../../utils/commonUtils";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../constants/SubscriptionStatus";

import { ReactComponent as FilterIcon } from "../../assets/images/app/allaya/filter-autocomplete.svg";
import { USER_STATUS } from "../../constants/UserStatus";
import moment from "moment";
import FilterModal from "./FilterModal";
import { FilterChips } from "./FilterChips";
import CustomSwitchInput from "../../components/Input/CustomSwitchInput";
import { findStatusChecked, getStatus } from "./utils";
import { ConfirmationModal } from "../../components/CustomModal";
import { MODAL_CONTENT_CONFIG } from "./ModalContentConfig";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { SUCCESS, showToast } from "../../utils/toastUtils";

let { NAME, EMAIL, AGE, STATUS, SUBSCRIPTION_PLAN, ACTION } = LABLES;

const recordUpdateSuccessMessage = "Status has been updated successfully";

const UserManagement = () => {
    const history = useHistory();
    const [selectedRecord, setSelectedRecord] = useState({ status: "", id: "" });
    const [modalConfig, setModalConfig] = useState(null);
    const [isFilterModal, setIsFilterModal] = useState(false);
    const [isUserStatusUpdating, setIsUserStatusUpdating] = useState(false);
    const [filters, setFilters] = useState({
        status: [],
        audioType: []
    });

    const {
        isFetching,
        page,
        handlePageClick,
        total,
        data,
        searchText,
        limit,
        refetch,
        handleSearchChange,
        handleSortingChange
    } = useLocalPaginatedRequest({
        key: getKey([MODULE_KEYS.USER_MANAGEMENT_LISTING]),
        requestFn: GetUsers,
        dataKey: "data",
        totalKey: "total",
        params: {
            ...(filters.status?.value && {
                status:
                    filters.status?.value == "Active" ? USER_STATUS.ACTIVE : USER_STATUS.INACTIVE
            }),
            ...(filters.audioType?.value && {
                tierType:
                    filters.audioType?.value == "Premium"
                        ? SUBSCRIPTION_STATUS.PREMIUM
                        : SUBSCRIPTION_STATUS.FREEMIUM
            })
        }
    });

    let { useMutate } = useRequestProcessor();
    let { mutate } = useMutate("", getKey(), (data) =>
        UpdateUserStatusById({ Id: selectedRecord?.id, bodyData: data })
    );

    // Open filter modal
    const openFilterModal = () => setIsFilterModal(true);

    // Handle applying filters
    const handleApplyFilter = (newFilters) => {
        setFilters(newFilters);
        setIsFilterModal(false);
    };

    const handleRemoveFilter = (type, value) => {
        setFilters((prevFilters) => {
            // Create a new object to avoid mutating the state
            const updatedFilters = { ...prevFilters };

            // Handle arrays (like `subCategory`)
            if (Array.isArray(updatedFilters[type])) {
                updatedFilters[type] = updatedFilters[type].filter((item) => item.value !== value);
            }

            // Handle objects (like `status` or `audioType`)
            if (typeof updatedFilters[type] === "object" && updatedFilters[type] !== null) {
                if (updatedFilters[type].value === value) {
                    updatedFilters[type] = null; // Clear the object if the value matches
                }
            }

            return updatedFilters;
        });
    };

    const handleActionInit = (id, status) => {
        setSelectedRecord({ id, status });
        let statusToSet = getStatus(status);
        setModalConfig(MODAL_CONTENT_CONFIG[statusToSet]);
    };

    const handleUserStatusUpdate = () => {
        setIsUserStatusUpdating(true);
        let statusToSet = getStatus(selectedRecord.status);

        const bodyData = { status: statusToSet };
        // Api call here
        mutate(bodyData, {
            onSuccess: async (res) => {
                setModalConfig(null);

                setIsUserStatusUpdating(false);

                showToast(SUCCESS, recordUpdateSuccessMessage);

                refetch();
            },
            onError: (err) => {
                // showToast(ERROR, err?.Message)
                setIsUserStatusUpdating(false);
            }
        });
    };

    const handleActionCancellation = () => {
        setModalConfig(null);
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.USER_MANAGEMENT}</title>
            </Helmet>
            <Container fluid>
                <SummaryCard
                    cardProps={{
                        style: { padding: "0px " } // Custom border radius
                    }}
                >
                    <Row className="pt-3 px-3">
                        <Col sm="12" md="4" lg="4">
                            <SearchBox
                                className="me-3 w-50 "
                                value={searchText}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col sm="12" md="5" lg="5"></Col>

                        <Col sm="12" md="3" lg="3">
                            {/* <SearchBox
                                className="w-100"
                                placeholder="Search & filter items"
                                value={searchText}
                                onChange={handleSearchChange}
                                icon={
                                    <div className="pointer" onClick={openFilterModal}>
                                        <FilterIcon />
                                    </div>
                                }
                            /> */}

                            <div
                                className={`filter-container d-flex justify-content-between align-items-center pointer`}
                                onClick={openFilterModal}
                            >
                                <div className="position-relative filter-text">Filter By</div>
                                <div className="">
                                    <FilterIcon />
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="px-3 my-2">
                        <FilterChips
                            filters={transformFiltersToArray(filters)}
                            onRemove={handleRemoveFilter}
                        />
                    </Row>

                    <DataTable
                        tableContainerClass=""
                        loading={isFetching}
                        data={data}
                        config={[
                            {
                                title: NAME,
                                render: (data) => truncateString(data?.fullName, 30)
                            },

                            {
                                title: EMAIL,
                                render: (data) => truncateString(data.email, 30) || "-"
                            },

                            {
                                title: AGE,
                                render: (data) => moment().diff(moment(data.dob), "years") || "-"
                            },

                            {
                                title: STATUS,

                                render: (data) =>
                                    (
                                        <div className="mb-0">
                                            <CustomSwitchInput
                                                label="Inactive"
                                                isChecked={findStatusChecked(
                                                    data?.status,
                                                    data?.fullName
                                                )}
                                                size="small"
                                                onClick={() =>
                                                    handleActionInit(data?.id, data?.status)
                                                }
                                            />
                                        </div>
                                    ) || "-"
                            },
                            {
                                title: SUBSCRIPTION_PLAN,

                                render: (data) => (
                                    <div
                                        className={`status-common-class ${SubscriptionStatus.getLabelClass(
                                            data?.tierType
                                        )}`}
                                    >
                                        {SubscriptionStatus.getDisplayTextKey(data?.tierType) ||
                                            "-"}
                                    </div>
                                )
                            },
                            {
                                title: ACTION,
                                render: (data) => {
                                    return (
                                        <div className="d-flex ">
                                            <img
                                                className="me-3"
                                                src={viewIcon}
                                                alt={"details icon"}
                                                role="button"
                                                onClick={() =>
                                                    history.push(
                                                        getParamsAttachedRoute(
                                                            APP_ROUTES.USER_MANAGEMENT_DETAILS,
                                                            {
                                                                userId: data?.id
                                                            }
                                                        )
                                                    )
                                                }
                                            />
                                        </div>
                                    );
                                }
                            }
                        ]}
                    />

                    <Pagination
                        rowLimit={limit}
                        onPageClick={handlePageClick}
                        currentPage={page}
                        totalData={total}
                        handleChange={(e) => handleSortingChange(e.target.value)}
                    />
                </SummaryCard>
            </Container>

            <FilterModal
                isModalOpen={isFilterModal}
                handleClose={() => setIsFilterModal(false)}
                handleApplyFilter={handleApplyFilter}
                selectedFilters={filters} // Pass the current filters to the modal
            />

            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={modalConfig}
                customImageSrc={modalConfig?.imageSrc}
                customTitle={modalConfig?.modalTitle}
                customSubText={modalConfig?.modalSubText}
                customYesBtnText={modalConfig?.yesButtonText}
                customNoBtnText={modalConfig?.noButtonText}
                onYes={handleUserStatusUpdate}
                onNo={handleActionCancellation}
                yesLoading={isUserStatusUpdating}
            />
        </div>
    );
};

export default UserManagement;
